import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import "preline/preline";

// import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import Description from "./Pages/Description";
import Attributions from "./Pages/Attributions";
import Contribution from "./Pages/Contribution";
import Entrepreneurship from "./Pages/Entrepreneurship";
import Notebook from "./Pages/Notebook";
import Engineering from "./Pages/Engineering";
import IntegratedHumanPractices from "./Pages/IntegratedHumanPractices";
import Education from "./Pages/Education";
import Experiments from "./Pages/Experiments";
import Results from "./Pages/Results";
import ProofOfConcept from "./Pages/ProofOfConcept";
import PlasmidDesign from "./Pages/PlasmidDesign";
import Model from "./Pages/Model";
import Team from "./Pages/Team"

import PageTemplate from "./Test/PageTemplate"
import Subpage from "./Demo/Subpage";
import SubpageFailed from "./Demo/Subpage_failed";
import TestSubpage from "./Demo/TestSubpage";
import Homepage from "./Demo/Homepage";


// var path = require('path')
// app.use(express.static(path.join(__dirname, 'public')));

function App() {

  const location = useLocation();

  useEffect(() => {
    window.HSStaticMethods.autoInit();
  }, [location.pathname]);

  return (
    <div className="selection:bg-blue-200 selection:text-black">
      {/*<Navbar/>*/}
      <Routes location={location} key={location.pathname}>
        <Route path="/stockholm" element={ <Home /> }/>
        <Route path="/stockholm/description" element={ <Description /> }/>
        <Route path="/stockholm/attributions" element={ <Attributions /> }/>
        <Route path="/stockholm/contribution" element={ <Contribution /> }/>
        <Route path="/stockholm/entrepreneurship" element={ <Entrepreneurship /> }/>
        <Route path="/stockholm/notebook" element={ <Notebook /> }/>
        <Route path="/stockholm/engineering" element={ <Engineering /> }/>
        <Route path="/stockholm/human-practices" element={ <IntegratedHumanPractices /> }/>
        <Route path="/stockholm/education" element={ <Education /> }/>
        <Route path="/stockholm/experiments" element={ <Experiments /> }/>
        <Route path="/stockholm/results" element={ <Results /> }/>
        <Route path="/stockholm/proof-of-concept" element={ <ProofOfConcept /> }/>
        <Route path="/stockholm/plasmid-design" element={ <PlasmidDesign /> }/>
        <Route path="/stockholm/model" element={ <Model /> }/>
        <Route path="/stockholm/team" element={ <Team /> }/>

        <Route path="/stockholm/test/page_template" element={ <PageTemplate /> }/>
        <Route path="/stockholm/demo/subpage" element={ <Subpage /> }/>
        <Route path="/stockholm/demo/subpage_failed" element={ <SubpageFailed /> }/>
        <Route path="/stockholm/demo/test_subpage" element={ <TestSubpage /> }/>
        <Route path="/stockholm/demo/homepage" element={ <Homepage /> }/>

      </Routes>
    </div>
  );
}

export default App;
